<form [formGroup]="formGroup">
  <section class="template-section" [matTooltip]="tooltip" [matTooltipDisabled]="disableTemplateTooltip" matTooltipShowDelay="500">
    <input
      class="hidden-upload-button"
      type="file"
      accept="{{ acceptableFileTypes }}"
      (change)="queueFileUpload($event.target)"
      (click)="fileUpload.value = null"
      #fileUpload
      />

      @if (proposedFilename || existingFilename) {
        <ul>
          <li>
            @if (existingFilename || proposedFilename) {
              <mat-icon fontIcon="file_present" style="vertical-align: top"></mat-icon>
            }
            @if (proposedFilename) {
              <span>{{ proposedFilename }}</span>
            }
            @if (existingFilename && !proposedFilename) {
              <span>{{ existingFilename }}</span>
            }
            <span class="action-icons">
              @if (existingFilename && !proposedFilename) {
                <mat-icon
                  fontIcon="file_download"
                  class="download"
                  (click)="downloadFile()"
                  [matTooltip]="'Download file'"
                  matTooltipShowDelay="500"
                ></mat-icon>
              }
              @if (existingFilename || proposedFilename) {
                @if(showInfoIcon) {
                  <mat-icon
                    fontIcon="info_outline"
                    class="template-info tooltip"
                    (click)="getInfo()"
                    (mouseover)="disableTemplateTooltip = true"
                    (mouseleave)="disableTemplateTooltip = false"
                  ></mat-icon>
                }
                <div class="supertooltiptext" [innerHTML]="templateInfo.message"></div>
                <mat-icon
                  fontIcon="close"
                  class="remove-template"
                  (click)="clearFile()"
                  tabindex="0"
                  [matTooltip]="'Remove file'"
                  matTooltipShowDelay="500"
                ></mat-icon>
              }
            </span>
          </li>
        </ul>
      }
      @if (!proposedFilename && !existingFilename) {
        <button class="upload-btn" tabindex="0" (click)="fileUpload.click()" appRipple>
          Upload File
          <mat-icon fontIcon="file_upload" style="vertical-align: bottom; margin-left: 5px"></mat-icon>
        </button>
      }
    </section>
    <!--  {{ formGroup.value | json }}-->
  </form>
